import React from "react";

export default function LineChartIcon() {
  return (
    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_500_3830)">
        <path
          d="M12 6.40821H12.1V6.30821V2V1.9H12H7.69202H7.59202V2V2.57544V2.67544H7.69202H11.3246V6.30821V6.40821H11.4246H12Z"
          fill="#FC4C4C"
          stroke="#FC4C4C"
          strokeWidth="0.2"
        />
        <path
          d="M0.336261 10.649L0.406972 10.7197L0.477662 10.649L3.93602 7.19063L5.73687 8.99148L5.80942 9.06403L5.88008 8.98965L11.9933 2.55461L12.0622 2.4821L11.9897 2.41322L11.5726 2.01709L11.5001 1.94823L11.4313 2.02072L5.79516 7.95326L4.00673 6.16483L3.93602 6.09412L3.86531 6.16483L-0.0707107 10.1008L-0.141441 10.1716L-0.0706906 10.2423L0.336261 10.649Z"
          fill="#FC4C4C"
          stroke="#FC4C4C"
          strokeWidth="0.2"
        />
      </g>
      <defs>
        <clipPath id="clip0_500_3830">
          <rect width="12" height="12" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
}
